import instance from "@/utils/require.js"

// 检验单--分页查询
export function apiQcCheckListSearch(data = {}) {
	return instance({
		url: "/aim/api/v3/qc_order/search",
		method: "post",
		data
	})
}

// 检验单--导出
export function apiQcOrderExport(data = {}) {
	return instance({
		url: "/aim/api/v3/qc_order/export_qcOrder",
		method: "post",
		data
	})
}
//根据工单导出FQC抽检记录
export function apiQCCheckSNExport(data = {}) {
	return instance({
		url: "/aim/api/v3/qc_order/export_qc_check_sn",
		method: "post",
		data
	})
}
export function apiQcOrderExportSn(data = {}) {
	return instance({
		url: "/aim/api/v3/qc_order/export_qcOrder_sn",
		method: "post",
		data
	})
}

export function apiQcCheckListDelete(data = {}) {
	return instance({
		url: "/aim/api/v3/qc_order/delete",
		method: "post",
		data
	})
}

export function apiQcBackCheck(data = {}) {
	return instance({
		url: "/aim/api/v3/qc_order/backCheckOrder",
		method: "post",
		data
	})
}

export function apiQcUpdateStatus(data = {}) {
	return instance({
		url: "/aim/api/v3/qc_order/updateStatus",
		method: "post",
		data
	})
}
export function apiQcCheckListDetail(data = {}) {
	return instance({
		url: "/aim/api/v3/qc_order/detail",
		method: "post",
		data
	})
}
export function apiQcCheckListDetailSN(data = {}) {
	return instance({
		url: "/aim/api/v3/qc_order/detailSn",
		method: "post",
		data
	})
}
export function apiQcCheckListAdd(data = {}) {
	return instance({
		url: "/aim/api/v3/qc_order/add",
		method: "post",
		data
	})
}

// 组装工单--客户列表
export function apiCustomerList(data = {}) {
	return instance({
		url: "/aim/api/v3/customer/list",
		method: "post",
		data
	})
}

// 获取AQL列表数据
export function apiGetAQLList(data = {}) {
	return instance({
		url: "/aim/api/v3/qc_sample_aql/getAQLList",
		method: "post",
		data
	})
}

export function apiVerify(data = {}) {
	return instance({
		url: "/aim/api/v3/qc_order/verify",
		method: "post",
		data
	})
}
